import { useState, useEffect, useCallback } from "react";
import { RouterProvider } from "react-router";
import { router } from "./routes";
import { config } from "./config";
import {
  AuthProvider,
  ErrorBoundary,
  SessionExpiredDialog,
  setSessionExpiredHandler,
} from "@duvi-agency/auth";

const authConfig = {
  brandName: "Duvi Platform",
  authUrl: config.authUrl,
  apiUrl: config.apiUrl,
};

export default function App() {
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    setSessionExpiredHandler(() => setSessionExpired(true));
    return () => setSessionExpiredHandler(() => {});
  }, []);

  const handleSessionExpiredConfirm = useCallback(() => {
    setSessionExpired(false);
    // Hard-reload to the SPA root. The root route renders the login
    // entry directly, so this guarantees the SPA loads (and not the
    // edge's auth-API integration on `/auth`) and gives the auth
    // provider a clean reinitialisation. See bug 0038 for context.
    window.location.href = "/";
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider config={authConfig}>
        <RouterProvider router={router} />
        <SessionExpiredDialog
          open={sessionExpired}
          onConfirm={handleSessionExpiredConfirm}
        />
      </AuthProvider>
    </ErrorBoundary>
  );
}
